import { render, staticRenderFns } from "./PresenceDistribution.vue?vue&type=template&id=03207c39&scoped=true&"
import script from "./PresenceDistribution.vue?vue&type=script&lang=js&"
export * from "./PresenceDistribution.vue?vue&type=script&lang=js&"
import style0 from "./PresenceDistribution.vue?vue&type=style&index=0&id=03207c39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03207c39",
  null
  
)

export default component.exports